const styles = `:host {
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  background-color: transparent;
  border: 1px solid transparent;
  min-height: 36px;
}
:host .expand-collapse-button {
  --goto-icon-color: var(--goto-icon-04);
  --goto-icon-size: 20px;
}
:host .end {
  flex-grow: 1;
  justify-content: flex-end;
  margin-right: var(--goto-spacing-03);
}
:host .positioning-region {
  border: none;
  color: var(--goto-text-01);
}
:host .positioning-region:hover {
  background-color: var(--goto-hover-secondary);
}
:host .positioning-region:active {
  background-color: var(--goto-pressed-secondary);
}

:host([unread]) .positioning-region slot {
  font: var(--goto-button-text-medium);
}

:host([size=small][unread]) .positioning-region slot {
  font: var(--goto-button-text-small);
}

:host([size=large][unread]) .positioning-region slot {
  font: var(--goto-button-text-large);
}

:host([selected]) .end {
  --goto-icon-color: design-token(text-04);
  --goto-presence-available: design-token(text-04);
  --goto-presence-busy: design-token(text-04);
  --goto-presence-away: design-token(text-04);
  --goto-presence-dnd: design-token(text-04);
  --goto-presence-offline: design-token(text-04);
  --goto-badge-color: design-token(icon-01);
  --goto-badge-background-color: design-token(ui-01);
}
:host([selected]) .positioning-region {
  background-color: var(--goto-interactive-01);
  color: var(--goto-text-04);
}
:host([selected]) .expand-collapse-button {
  --goto-icon-color: design-token(text-04);
}

:host([selected])::after {
  display: none;
}

:host(:focus-visible) {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host(:focus-visible) .positioning-region {
  border: none;
  border-radius: 0;
  color: var(--goto-text-01);
}

:host([selected]:focus-visible) .positioning-region {
  color: var(--goto-text-04);
}

:host(.nested) .expand-collapse-button:hover {
  background-color: transparent;
}

:host([size=small]) {
  min-height: 32px;
}
:host([size=small]) .expand-collapse-button {
  --goto-icon-size: 16px;
}
:host([size=small]) .positioning-region slot {
  font: var(--goto-caption-default-01);
}
:host([size=small]) .positioning-region,
:host([size=small]) .content-region {
  height: 32px;
}
:host([size=small]) .items {
  cursor: default;
}

:host([size=large]) {
  min-height: 44px;
}
:host([size=large]) .expand-collapse-button {
  --goto-icon-size: 24px;
}
:host([size=large]) .positioning-region slot {
  font: var(--goto-body-medium);
}
:host([size=large]) .positioning-region,
:host([size=large]) .content-region {
  height: 44px;
}

:host([expanded]) .expand-collapse-button {
  transform: rotate(90deg);
}

:host([selected]) .expand-collapse-button {
  --goto-icon-color: var(--goto-icon-02);
}

:host([disabled]) .expand-collapse-button {
  --goto-icon-color: design-token(disabled-04);
}
:host([disabled]) .content-region,
:host([disabled]) .expand-collapse-button {
  cursor: default;
}
:host([disabled]) .positioning-region {
  color: var(--goto-disabled-04);
}
:host([disabled]) .positioning-region:hover, :host([disabled]) .positioning-region:active {
  background-color: transparent;
}`; export default styles;